import { includes, indexOf, filter, uniq, map, get } from 'lodash';

const COLORS = 'Color';
const SIZES = 'Size';

export function hasOption(product, name) {
  return includes(product.options, name);
}

export function optionIndex(product, name) {
  return indexOf(product.options, name);
}

export function hasColors(product) {
  return hasOption(product, COLORS);
}

export function hasSizes(product) {
  return hasOption(product, SIZES);
}

export function firstColor(product) {
  const position = optionIndex(product, COLORS);
  return get(product, `variants[0].options[${position}]`);
}

// Returns all variants that match the selected color
export function variantsForColor(product, selectedColor) {
  const position = optionIndex(product, COLORS);
  return filter(product.variants, variant => variant.options[position] === selectedColor);
}

// Returns all uniq colors for the product
export function colorsForProduct(product) {
  const position = optionIndex(product, COLORS);
  return uniq(map(product.variants, (v) => v.options[position]));
}

export function sizesForProduct(product) {
  const position = optionIndex(product, SIZES);
  return uniq(map(product.variants, (v) => v.options[position]));
}


// WEBPACK FOOTER //
// ./assets/scripts/components/Product/helpers.js